import {combineReducers} from 'redux';
import widgets from './widgets.reducer';

const reducer = combineReducers({
    widgets
});

export default reducer;



// WEBPACK FOOTER //
// ./src/main/content/analytics/store/reducers/index.js